import { client } from './client'

const getHelpCategories = async (locale, countryId = '') => {
  client.defaults.headers['Accept-Language'] = locale
  const response = await client.get(`/v2/help/categories?country=${countryId}`)
  return response.data
}

const getHelpCategoryDetails = async (locale, slug, countryId = '') => {
  client.defaults.headers['Accept-Language'] = locale
  const response = await client.get(`/v2/help/category/slug/${slug}?country=${countryId}`)
  return response.data
}

const getHelpArticleBySlug = async (locale, slug) => {
  client.defaults.headers['Accept-Language'] = locale
  const response = await client.get(`/v2/help/article/slug/${slug}`)
  return response.data
}

const getAllHelpArticles = async (locale) => {
  client.defaults.headers['Accept-Language'] = locale
  const response = await client.get('/v2/help/articles/all')
  return response.data
}

const getHelpPopularArticles = async (locale, countryId = '') => {
  client.defaults.headers['Accept-Language'] = locale
  const response = await client.get(`/v2/help/articles/popular?country=${countryId}`)
  return response.data
}

const searchHelpArticles = async (locale, query, first = 100, skip = 0, countryId = '') => {
  client.defaults.headers['Accept-Language'] = locale
  const response = await client.get(`/v2/help/articles/search?query=${query}&first=${first}&skip=${skip}&country=${countryId}`)
  return response.data
}

export {
  getHelpCategories,
  getHelpCategoryDetails,
  getAllHelpArticles,
  getHelpArticleBySlug,
  getHelpPopularArticles,
  searchHelpArticles
}
